<template>
    <div class="technologies">
        <section class="page">
            <header class="main">
                <div class="container">
                    <h4>Technologies</h4>
                </div>
            </header>
            <div class="page-content">
                <div class="container">
                    <div class="row justify-content-between">
                        <div class="col-12 col-md-5">
                            <h1 class="title">Frontend</h1>
                            <p>
                                HTML5
                                CSS3 / SASS / LESS
                                Angular.js
                                Angular
                                Vue.js
                            </p>
                        </div>
                        <div class="col-12 col-md-5">
                            <h1 class="title">Backend</h1>
                            <p>
                                Couple works abount frontend
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "technologies",
  components: {}
};
</script>
<style lang="scss">
</style>
